import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { encode as base64_encode } from "base-64";
import OtpPage from "../components/OtpPage";
import { ApiName } from "../Constant/ApiName";
import { fetchApiGet, fetchApiPost } from "../utils/FetchApi";
import tagManagerEvents from "../utils/GoogleTagManager";
import { setCookie } from "../utils/CommonFunction";

type Props = {
  jwtToken: string | null;
};

let uuid = "";

const OtpPageScreen = (props: Props) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  // state
  const [inputRef, setInputRef] = useState<React.RefObject<HTMLInputElement>[]>(
    [
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
    ]
  );
  const [otp, setOtp] = useState({
    one: "",
    two: "",
    three: "",
    four: "",
  });
  const [error, setError] = useState("");
  const [showErro, setShowErro] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (!state?.msisdn) {
      navigate("/landing");
    } else {
      uuid = state?.uuid;
      if (state.heFlag) {
        let _otp = state.otp.split("");
        let tempOTP = { ...otp };
        tempOTP.one = _otp[0];
        tempOTP.two = _otp[1];
        tempOTP.three = _otp[2];
        tempOTP.four = _otp[3];
        setOtp(tempOTP);
      }
      // handleCheckUtms();
    }
  }, []);
  // function

  const handleOtpInput = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newValue = e.target.value;
    if (!isNaN(newValue as any) && newValue !== " ") {
      setOtp({
        ...otp,
        [e.target.name]: newValue,
      });
      if (e.target.value.length === 1) {
        const nextInput = inputRef[index + 1];
        if (nextInput?.current) {
          nextInput.current.focus();
        }
      }
    } else {
      setLoader(false);
      setShowErro(true);
      setError("Please enter a valid OTP");
    }
  };
  const handleBackspace = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ): void => {
    if (e.keyCode === 8) {
      setShowErro(false);
      const target = e.target as HTMLInputElement;
      if (target.value.length === 0 && index !== 0) {
        (inputRef[index - 1].current as HTMLInputElement).focus();
      }
    }
  };
  const handleOtpSubmit = () => {
    let _otp: string = otp.one + otp.two + otp.three + otp.four;
    if (_otp.length === 4) {
      setLoader(true);
      if (state.checkUserStatus) {
        handleLogin(_otp);
      } else {
        let endPoint =
          ApiName.subscribe + state.msisdn + "&otp=" + _otp + "&uuid=" + uuid;
        handleSubscribeWeb(endPoint);
      }
    } else {
      setLoader(false);
      setShowErro(true);
      setError("Enter a Valid OTP");
    }
  };

  const handleSubscribeWeb = async (_ApiName: string) => {
    try {
      let response = await fetchApiGet(props.jwtToken, _ApiName);
      if (response.results.code === "0" && response.status === 200) {
        tagManagerEvents("SUBSCRIBE", state.utm);
        let url = window.location.origin;

        setCookie(state.msisdn, state.subPackage, response.results.session_id);

        url = `${url}/home`;

        if (url.includes("http:")) {
          url = url.replace("http", "https");
        }
        window.location.replace(url);
      } else if (
        response.status === 500 &&
        response.message.toLowerCase() === "otp validation failed"
      ) {
        setShowErro(true);
        setError("Otp validation failed");
        setLoader(false);
      } else {
        tagManagerEvents("SUBSCRIBE_FAIL", state.utm);
        setShowErro(true);
        setError("Unable to Subscribe");
        setLoader(false);
      }
    } catch (error) {
      setShowErro(true);
      setError("Something went wrong, Please try again.");
      setLoader(false);
    }
  };

  const handleLogin = async (otp: string) => {
    try {
      let endPoint = `${ApiName.loginWeb}?msisdn=${state.msisdn}&otp=${otp}&uuid=${uuid}`;
      let response = await fetchApiGet(props.jwtToken, endPoint);

      if (response.status === 200) {
        if (
          response.results.result === "0" &&
          response.results.desc.toLowerCase() === "success."
        ) {
          let url = window.location.origin;

          setCookie(
            state.msisdn,
            state.subPackage,
            response.results.session_id
          );

          url = `${url}/home`;
          if (url.includes("http:")) {
            url = url.replace("http", "https");
          }
          window.location.replace(url);
          setLoader(false);
        } else {
          // setShowErro(true);
          setError("Unable to subscribe user, Please try again.");
          setLoader(false);
        }
      } else if (
        response.status === 500 &&
        response.message.toLowerCase() === "otp validation failed"
      ) {
        setShowErro(true);
        setError("Otp validation failed");
        setLoader(false);
      } else {
        // setShowErro(true);
        setError("Unable to subscribe user, Please try again.");
        setLoader(false);
      }
    } catch (err) {
      // setShowErro(true);
      setError("Something went wrong, Please try again.");
      setLoader(false);
    }
  };

  const handleSignupWeb = async () => {
    try {
      setOtp({
        one: "",
        two: "",
        three: "",
        four: "",
      });
      setShowErro(false);
      let endPoint = "";
      if (state.checkUserStatus) {
        endPoint = `${ApiName.signupwebActive}?msisdn=${state.msisdn}&os=""`;
      } else {
        endPoint = `${ApiName.signupweb}?msisdn=${state.msisdn}&os=""`;
      }
      let response = await fetchApiGet(props.jwtToken, endPoint);

      if (response.status === 200) {
        uuid = response.results.uuid;
        if (state.heFlag) {
          const _otp = response?.results?.desc?.split("");
          setOtp({
            one: _otp[0],
            two: _otp[1],
            three: _otp[2],
            four: _otp[3],
          });
        }
      }
    } catch (error) {
      console.log("signUpWeb" + error);
      setShowErro(true);
      setError("Something went wrong, Please try again.");
      setLoader(false);
    }
  };

  return (
    <>
      <OtpPage
        msisdn={state.msisdn}
        inputRef={inputRef}
        otp={otp}
        handleOtpInput={handleOtpInput}
        handleBackspace={handleBackspace}
        handleOtpSubmit={handleOtpSubmit}
        error={error}
        loader={loader}
        showErro={showErro}
        handleSignupWeb={handleSignupWeb}
      />
    </>
  );
};

export default OtpPageScreen;
